import PropTypes from 'prop-types';

function Sliders({ contentType = 'sliders' }) {
  return (
    <div>
      <p>{contentType} component</p>
    </div>
  );
}

// @TODO: define real props for the Sliders based on it requirements
Sliders.propTypes = {
  contentType: PropTypes.string,
};

export default Sliders;
